const isDevelopment = process.env.NODE_ENV === "development";
const config = {
  isDevelopment,
  cloudGraphqlUrl: isDevelopment ? "http://localhost:5250/graphql" : ""
}

export default config;
